import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Masked line-by-line reveal. Reliable trigger via useInView hook.
export const TextReveal = ({
  text,
  className = "",
  delay = 0,
  stagger = 0.12,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const lines = String(text).split("\n");
  return (
    <span ref={ref} className={className} aria-label={text}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={inView ? { y: "0%" } : { y: "110%" }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
